import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.03 7.783c0 3.247 2.354 5.46 4.998 5.917a.556.556 0 0 1-.19 1.096C3.733 14.258.918 11.64.918 7.783c0-1.64.746-2.927 1.617-3.907.624-.702 1.337-1.272 1.911-1.709H2.701a.533.533 0 1 1 0-1.066h3.2c.294 0 .533.238.533.533v3.2a.533.533 0 0 1-1.067 0V2.865l-.001.002c-.61.46-1.355 1.021-2 1.747-.762.858-1.336 1.894-1.336 3.169m11.848.434c0-3.213-2.304-5.412-4.914-5.902a.556.556 0 1 1 .205-1.093c3.066.576 5.821 3.179 5.821 6.995 0 1.639-.746 2.927-1.617 3.907-.623.702-1.337 1.272-1.911 1.708h1.746a.533.533 0 1 1 0 1.067h-3.2a.533.533 0 0 1-.534-.533v-3.2a.533.533 0 1 1 1.067 0v1.968l.002-.001c.61-.46 1.354-1.022 2-1.748.762-.857 1.335-1.894 1.335-3.168",
		clipRule: "evenodd"
	})
});
const Memo = memo(SvgReload);
export default Memo;
